export const page = async () => { 
    var modalBacano = document.getElementById("modalBacano");
    var closeModalBacano = document.getElementById("closeModalBacano");
    var contentVideoBacano = document.getElementById("content-video-bacano");
    var body = document.querySelector("body");
    
    let secciones = Array.from(document.getElementsByClassName('item-content') as HTMLCollectionOf<HTMLElement>);
    secciones.forEach((element) =>{
        element.onclick = function(event) {
            let urlVideo = element.getAttribute('data-url-video');
            contentVideoBacano.setAttribute('src', urlVideo);
            modalBacano.style.display = "block";
    
            body.style.position = "static";
            body.style.height = "100%";
            body.style.overflow = "hidden";
        }
    });
    
    closeModalBacano.onclick = function() {
        modalBacano.style.display = "none";
    
        body.style.position = "inherit";
        body.style.height = "auto";
        body.style.overflow = "visible";
        contentVideoBacano.setAttribute('src', "");
    }
    
    window.onclick = function(event) {
        if (event.target == modalBacano) {
            modalBacano.style.display = "none";
    
            body.style.position = "inherit";
            body.style.height = "auto";
            body.style.overflow = "visible";
            contentVideoBacano.setAttribute('src', "");
        }
    }
}